<template>
  <div class="content_main">
      <div>
        <a-button type="primary" @click="setInventory" :disabled="selectedRowKeysFlow.length < 1"> 确认 </a-button>
        <a-button type="primary" @click="reject" :disabled="selectedRowKeysFlow.length < 1"> 驳回</a-button>
      </div>
      <div class="content_main_top">
        <a-input
          class="a_select_self margin_self"
          v-model="serchInfo.purchaseCode"
          allowClear
          placeholder="采购单号"
          @keyup.enter.native="serch_get_lis3"
        />
        <a-input
          class="a_select_self margin_self"
          v-model="serchInfo.createBy"
          allowClear
          placeholder="申购人"
          @keyup.enter.native="serch_get_lis3"
        />
		<a-input
          class="a_select_self margin_self"
          v-model="serchInfo.assetSn"
          allowClear
          placeholder="物品编号"
          @keyup.enter.native="serch_get_lis3"
        />
		<a-input
          class="a_select_self margin_self"
          v-model="serchInfo.name"
          allowClear
          placeholder="物品名称"
          @keyup.enter.native="serch_get_lis3"
        />
        <!-- <a-select
          show-search
          allowClear
          placeholder="公司名称"
          class="margin_self"
          @change="handlecompany"
          v-model="serchInfo.companyId"
          @keyup.enter.native="serch_get_lis3"
          style="width: 120px"
        >
          <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
            {{ item.title }}
          </a-select-option>
        </a-select>
        <a-tree-select
          allowClear
          :treeData="deptTree"
          v-model="serchInfo.deptId"
          :disabled="!serchInfo.companyId"
          placeholder="部门名称"
          @keyup.enter.native="serch_get_lis3"
          class="margin_self"
          style="width: 120px"
          treeDefaultExpandAll
        >
        </a-tree-select> -->
        <a-range-picker
          v-model="serchInfo.createTimelist"
          valueFormat="YYYY-MM-DD"
          :placeholder="['移交开始时间', '移交结束时间']"
          style="width: 230px; margin-right: 10px"
          @keyup.enter.native="serch_get_lis3"
        />
        <a-button type="primary" @click="serch_get_lis3"> 查询</a-button>
        <a-button type="primary" @click="reset"> 重置 </a-button>
      </div>
      <div class="content_main_center_scroll" id="content_main_center_scroll" style="height: calc(100% - 85px);">
        <a-table
          :data-source="lis3"
          bordered
          :loading="loading"
          :pagination="pagination3"
          :row-selection="{ selectedRowKeys: selectedRowKeysFlow, onChange: onSelectChangeFlow, type: checkbox }"
          @change="handleTableChange3"
          :scroll="{ x: 1500, y: scroll_y, scrollToFirstRowOnChange: true }"
        >
          <a-table-column key="index" title="序号" data-index="index" width="70px">
            <template scope="text, record, index"
              >{{ (pagination3.current - 1) * pagination3.pageSize + index + 1 }}
            </template>
          </a-table-column>
          <a-table-column key="purchaseCode" width="140px" ellipsis="true" title="采购单号" data-index="purchaseCode" />
          <!-- <a-table-column key="purchaseCode" width="140px" ellipsis="true" title="申请单号"
							data-index="purchaseCode" /> -->
          <a-table-column key="createBy" width="120px" ellipsis="true" title="申购人" data-index="createBy" />
          <!-- <a-table-column key="dictLabel" width="120px" ellipsis="true" title="物品类型"
							data-index="dictLabel" /> -->
          <a-table-column key="assetSn" width="100px" ellipsis="true" title="物品编号" data-index="assetSn" />
          <a-table-column key="name" width="120px" ellipsis="true" title="物品名称" data-index="name" />
          <a-table-column key="model" width="120px" ellipsis="true" title="规格型号" data-index="model" />
          <a-table-column key="deptName" width="120px" ellipsis="true" title="责任部门" data-index="deptName" />
          <!-- <a-table-column key="purchaser" width="120px" ellipsis="true" title="采购人"	data-index="purchaser" /> -->
          <a-table-column key="keeper" width="120px" ellipsis="true" title="保管人" data-index="keeper" />
          <a-table-column key="purchaseDate" width="120px" ellipsis="true" title="采购时间" data-index="purchaseDate" />
          <a-table-column key="handler" width="120px" ellipsis="true" title="移交人" data-index="handler" />
          <a-table-column key="createTime" width="120px" ellipsis="true" title="申请移交时间" data-index="createTime" />
          <!-- <a-table-column key="deptName" width="120px" ellipsis="true" title="归属部门"
							data-index="deptName" /> -->
        </a-table>
      </div>
    </div>
</template>
<script>
import { limitCompany } from '@/utils/limitCompany'
import { get_dict } from '@/utils/unit_axios'
import { dept_get } from '@/api/assetmenag'
import { getDeptListEnable2 } from '@/api/system'
import {
  selectBizPurchaseApplyList,
  updateBizGoodsInfoWarehousing,
  storage_no_transfer,
  storage_transfer,
  transfer_record,
  getUncheckPurchaseListByUser,
  keep_storage,
  check_transfer,
  uncheckPurchase,
  tree_all,
} from '@/api/purchase'
export default {
  data() {
    return {
      scroll_y: 150,
      selectedRowKeysTab: [],
      lis3: [],
      serchInfo: {
		  name: '',
		  assetSn: '',
        purchaseCode: '',
        createBy: '',
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
      },
      companylist: [],
      deptTree: [],
      lis3: [],
      form: {
        item_type: 1, //	整数	入库类型：固定传2
        order_id: '', //	整数	订单id
        orderCode: '',
        asset_sn: '', //	字符串	资产编号
        asset_type: undefined, //资产类别
        company_id: '', //公司id
        company_name: this.$store.state.user.info.company, //公司名称
        name: '', //	字符串	名称
        unit: '', //	字符串	单位
        state: undefined, //	整数	状态
        model: '', //	字符串	规格型号
        storage_loc: '', //	字符串	存放位置
        storage_cond: '', //	字符串	存放条件
        purchase_time: '', //	日期字符串	采购时间
        purchase_price: '', //	整数	采购价格*100
        dept_id: undefined, //	整数	部门id
        value: '', //	整数	估值*100
        amount: '',
        actualAmount: '',
        singlePrice: '',
        charger: '', //	字符串	责任人
        operator: this.$store.state.user.info.userName, //	字符串	入库人
        keeper: this.$store.state.user.info.userName, //	字符串	保管人
        arrive_time: '', //	日期字符串	到货日期
        dealer: '', //	字符串	供应商
        manufacturer: '', //	字符串	生产厂家
        factory_sn: '', //	字符串	出厂编号
        is_inspected: '0', //	布尔值	是否已检定
        inspect_cycle: '', //	字符串	检定周期
        inspect_time: '', //	日期字符串	检定日期
        precisions: '', //	字符串	精度
        inspect_result: '', //	字符串	检定结果
        permit: '', //	字符串	准用说明
        notes: '', //	字符串	备注
        att_path: '', //	字符串	附件地址，以；隔开
      },
      goodInfo: {
        id: '',
        name: '',
        company_id: '',
      },
      pagination3: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      selectedRowKeysFlow: [],
      rowId: [],
    }
  },
  created() {
    this.get_list3()
  },
  mounted() {
    limitCompany().then((res) => {
      res.forEach((item) => {
        if (item.deptId) {
          this.companylist.push(item)
        }
      })
    })
    // 		tree_all().then(res => {
    // 	if (res.code == 200) {
    // 		this.companylist = res.data[0]
    // 			this.companylist.unshift({
    // 			deptId: 0,
    // 			title: '所有公司',
    // 			children: [],
    // 		})

    // 	}
    // })
    // 	get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // 	this.companylist.forEach((item) => {
    // 		if (item.dept_name == this.form.company_name) {
    // 			this.formdeptlist = item.child_lis
    // 			this.goodInfo.company_id = item.dept_id
    // 		}
    // 	})
    // })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() 
      }, 1000)
    })

    //  {
    //         keeperId:  this.$store.getters.userInfo.userId,
    //         ischecked: 0

    //     }
    // transfer_record(

    // ).then((res) => {
    //     console.log( this.$store.getters.userInfo.useId)
    // 		if (res.code == 200) {
    // 			this.lis3 = res.data.list
    //         }
    // })
  },
  created() {
    this.get_list3()

    // get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    get_dict('goodStatus', (res) => {
      console.log(res)
      this.statusMap = res
    })
    // getDeptListEnable2().then((res) => {
    //     console.log(res.rows, 'res.row===================s')
    // 	const data = res.rows
    // 	if (data.length > 0) {
    // 		const min = Math.min(...data.map((m) => m.parentId))
    // 		this.buildtree2(data, this.deptTree2, this.$store.getters.userInfo.companyId)
    // 	}
    // })
  },
  methods: {
    //   驳回
    reject() {
      var _this = this
      this.$confirm({
        title: '确认未收到该资产?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          uncheckPurchase({
            list: _this.rowId,
          }).then((res) => {
            if (res.code == 200) {
              _this.$message.success('提交成功')
              //刷新列表
              _this.get_list3()
			  _this.selectedRowKeysFlow = []
            } else {
              return _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {},
      })
    },
    // 确认移交
    setInventory() {
      var _this = this
      this.$confirm({
        title: '确认已收到该资产?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          check_transfer({
            list: _this.rowId,
          }).then((res) => {
            if (res.code == 200) {
              _this.$message.success('提交成功')
              //刷新列表
              _this.get_list3()
			  _this.selectedRowKeysFlow = []
            } else {
              return _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {},
      })
    },
    // 	//选中物品
    onSelectChangeFlow(selectedRowKeys, val) {
      console.log(selectedRowKeys, val, '===========================')
      this.selectedRowKeysFlow = selectedRowKeys
      this.rowId = []
      val.forEach((item) => {
        console.log(item.id, 'item.id==============================')
        this.rowId.push(item.id)
      })
      console.log(this.rowId, 'this.rowId==============================')
      // this.lis3.name = val[0]
    },
    // //选中物品
    // onSelectChange(selectedRowKeys, val) {
    //     console.log(selectedRowKeys, val, '===========================')
    // 	this.selectedRowKeysFlow = selectedRowKeys
    // 	this.lis3.name = val[0].name
    // 	// this.selectval = val[0]
    // },
    handleTableChange3(pagination, filters, sorter) {
      console.log(pagination, 'pagination====================')
      this.pagination3.current = pagination.current
      this.pagination3.pageSize = pagination.pageSize
      this.loading = true
      this.get_list3()
    },
    reset() {
      this.serchInfo = {
		  name: '',
		  assetSn: '',
        purchaseCode: '',
        createBy: '',
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
      }
    },
    serch_get_lis3() {
      this.loading = true
      this.pagination3.current = 1
      this.get_list3()
    },
    get_list3() {
      // transfer_record
      getUncheckPurchaseListByUser({
		  name: this.serchInfo.name,
		  assetSn: this.serchInfo.assetSn,
        pageIndex: this.pagination3.current,
        pageSize: this.pagination3.pageSize,
        purchaseCode: this.serchInfo.purchaseCode,
        createBy: this.serchInfo.createBy,
        // companyId: this.serchInfo.companyId,
        // deptId: this.serchInfo.deptId,
        startTime: this.serchInfo.createTimelist.length ? this.serchInfo.createTimelist[0] : '',
        endTime: this.serchInfo.createTimelist.length ? this.serchInfo.createTimelist[1] : '',
        keeperId: this.$store.getters.userInfo.userId,
        isChecked: 0,
      }).then((res) => {
        if (res.code == 200) {
          this.lis3 = res.data.list
          console.log(this.lis3, 'this.lis3==========================')
          const pagination = {
            ...this.pagination3,
          }
          pagination.total = res.data.total
          this.pagination3 = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    //切换公司
    handlecompany(e) {
      this.serchInfo.deptId = undefined
      this.deptTree = []
      console.log(this.companylist, 'this.companylist===============================')
      console.log(e, 'e===============================')
      this.companylist.forEach((item) => {
        if (item.deptId == e && item.children.length != 0) {
          this.deptTree = item.children
        }
      })
    },
  },
  // buildtree2(list, arr, parentId) {
  // 		list.forEach((item) => {
  // 			if (item.parentId === parentId) {
  // 				var child = {
  // 					key: item.deptId,
  // 					value: item.deptId, // value是给modal的select用的，2者属性不一样
  // 					title: item.deptName,
  // 					scopedSlots: {
  // 						title: 'title',
  // 					},
  // 					children: [],
  // 				}
  // 				this.buildtree2(list, child.children, item.deptId)
  // 				if (child.children.length === 0) {
  // 					delete child.children
  // 				}
  // 				arr.push(child)
  // 			}
  // 		})
  // 	},
}
</script>
<style>
.ant-table td {
  white-space: nowrap;
}
</style>
